<template>
  <div class="show_data">
    <div class="box">
      <p>千次费用</p>
      <p>{{ img.kiloimpressions_amt }}</p>
    </div>
    <div class="box">
      <p>点击率</p>
      <p>{{ (img.clicks_rate * 100).toFixed(2) }}%</p>
    </div>
    <div class="box">
      <p>转化率</p>
      <p>{{ (img.conversions_rate * 100).toFixed(2) }}%</p>
    </div>
    <div class="box">
      <p>展示次数</p>
      <p>{{ img.pv }}</p>
    </div>
    <div class="box">
      <p>点击次数</p>
      <p>{{ img.clicks_cnt }}</p>
    </div>
    <div class="box">
      <p>加购次数</p>
      <p>{{ img.add_cart_cnt }}</p>
    </div>
    <div class="box">
      <p>支付次数</p>
      <p>{{ img.checkout_cnt }}</p>
    </div>
    <div class="box">
      <p>单次展示成本</p>
      <p>{{ parseFloat(img.single_clicks_amt).toFixed(2) }}</p>
    </div>
    <div class="box">
      <p>单次点击成本</p>
      <p>{{ parseFloat(img.single_impressions_amt).toFixed(2) }}</p>
    </div>
    <div class="box">
      <p>单次加购成本</p>
      <p>{{ parseFloat(img.single_cart_amt).toFixed(2) }}</p>
    </div>
    <div class="box">
      <p>单次支付成本</p>
      <p>{{ parseFloat(img.single_checkout_amt).toFixed(2) }}</p>
    </div>
    <div class="box">
      <p>近15天广告成本</p>
      <p>{{ parseFloat(img.spend_15_day_amt).toFixed(2) }}</p>
    </div>
    <div class="box">
      <p>广告成本</p>
      <p>{{ parseFloat(img.spend_cny_amt).toFixed(2) }}</p>
    </div>
    <div class="box">
      <p>订单量</p>
      <p>{{ img.order_cnt }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style lang="scss" scoped>
.show_data {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .box {
    width: 25%;
    margin-bottom: 6px;
    p:last-child {
      color: red;
      margin-top: 3px;
    }
  }
}
</style>
